import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
    AddInternalMarketerProduct,
    addInternalMarketerProductAction
} from '../../../../actions/marketer/internal/addInternalMarketerProduct';
import { ADD_INTERNAL_MARKETER_PRODUCT_ACCESS } from '../../../../actions/marketer/internal/addInternalMarketerProductAccess';
import {
    ResetInternalMarketerEditProduct,
    resetInternalMarketerEditProductAction
} from '../../../../actions/marketer/internal/resetInternalMarketerEditProduct';
import {
    UpdateInternalMarketerPageStatus,
    updateInternalMarketerPageStatusAction
} from '../../../../actions/marketer/internal/updateInternalMarketerPageStatus';
import { selectMarketersSortParams } from '../../../../selectors/marketers';
import { showNoticeMessage } from '../../../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../../../service/StoreFactory';
import { NoticeType } from '../../../../typings/grid';
import { MarketersPageStates } from '../../../../typings/marketers';
import { State } from '../../../../typings/state';

import * as keyset from './addInternalMarketerProductAccessEpic.i18n';

const i18n = i18nFactory(keyset);

type EpicActions = AddInternalMarketerProduct | UpdateInternalMarketerPageStatus | ResetInternalMarketerEditProduct;

export const addInternalMarketerProductAccessEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(ADD_INTERNAL_MARKETER_PRODUCT_ACCESS),
        mergeMap(
            (): Observable<EpicActions> => {
                const {
                    editProduct: { access, placeIds, id: productId },
                    marketer: { id: marketerId }
                } = store$.value.marketerCard;

                return from(deps.marketersDataProvider.addProductAccess(marketerId, productId, access, placeIds)).pipe(
                    mergeMap(product => {
                        const sortParams = selectMarketersSortParams(store$.value);

                        showNoticeMessage(NoticeType.success, i18n('add-success'));

                        return of(
                            addInternalMarketerProductAction(product, sortParams),
                            updateInternalMarketerPageStatusAction(MarketersPageStates.LOADED),
                            resetInternalMarketerEditProductAction()
                        );
                    }),
                    catchError(() => {
                        showNoticeMessage(NoticeType.error, i18n('error'));

                        return of(updateInternalMarketerPageStatusAction(MarketersPageStates.PENDING));
                    })
                );
            }
        )
    );
